import React from 'react';
import { FiGrid, FiLayers, FiUsers, FiZap } from 'react-icons/fi';
import { ROUTES } from './routes';
import { INTEGRATION } from 'constants';
import { useSelector } from 'react-redux';

export const MAIN_SIDEBAR_OPTIONS = () => {
  const { user } = useSelector((state) => state.auth);
  const isAppSumoTier3 =
    user?.subscriptions?.current_subscription?.plan_name === 'AppSumo Tier3';
  const isBusinessPlan =
    user?.subscriptions?.current_subscription?.plan_name === 'Business Plan' ||
    user?.subscriptions?.current_subscription?.plan_name === 'Lifetime Business Plan';

  const baseOptions = [
    {
      id: 'dashboard',
      path: ROUTES.HomePage,
      label: 'Dashboard',
      icon: <FiGrid size={18} />,
    },
    {
      id: 'planner',
      path: ROUTES.Planner,
      label: 'Planner',
      icon: (
        <svg
          width="18"
          height="18"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.6667 2H3.33333C2.59695 2 2 2.59695 2 3.33333V12.6667C2 13.403 2.59695 14 3.33333 14H12.6667C13.403 14 14 13.403 14 12.6667V3.33333C14 2.59695 13.403 2 12.6667 2Z"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.66667 4.66667H4.66667V10.6667H6.66667V4.66667Z"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.3333 4.66667H9.33333V8H11.3333V4.66667Z"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },
    {
      id: 'projects',
      path: ROUTES.Projects,
      label: 'Campaigns',
      icon: <FiLayers size={18} />,
    },
    {
      id: 'templates',
      path: ROUTES.Templates,
      label: 'Templates',
      icon: <FiZap size={18} />,
    },
    {
      id: 'library',
      path: ROUTES.Library,
      label: 'Library',
      icon: (
        <svg
          width="18"
          height="18"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.6668 12.6667C14.6668 13.0203 14.5264 13.3594 14.2763 13.6095C14.0263 13.8595 13.6871 14 13.3335 14H2.66683C2.31321 14 1.97407 13.8595 1.72402 13.6095C1.47397 13.3594 1.3335 13.0203 1.3335 12.6667V3.33333C1.3335 2.97971 1.47397 2.64057 1.72402 2.39052C1.97407 2.14048 2.31321 2 2.66683 2H6.00016L7.3335 4H13.3335C13.6871 4 14.0263 4.14048 14.2763 4.39052C14.5264 4.64057 14.6668 4.97971 14.6668 5.33333V12.6667Z"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },
    {
      id: 'integration',
      path: INTEGRATION,
      label: 'Integrations',
      icon: (
        <svg
          width="18"
          height="18"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_21887_11021)">
            <path
              d="M4.00016 4.00065H4.00683M4.00016 12.0007H4.00683M2.66683 1.33398H13.3335C14.0699 1.33398 14.6668 1.93094 14.6668 2.66732V5.33398C14.6668 6.07036 14.0699 6.66732 13.3335 6.66732H2.66683C1.93045 6.66732 1.3335 6.07036 1.3335 5.33398V2.66732C1.3335 1.93094 1.93045 1.33398 2.66683 1.33398ZM2.66683 9.33398H13.3335C14.0699 9.33398 14.6668 9.93094 14.6668 10.6673V13.334C14.6668 14.0704 14.0699 14.6673 13.3335 14.6673H2.66683C1.93045 14.6673 1.3335 14.0704 1.3335 13.334V10.6673C1.3335 9.93094 1.93045 9.33398 2.66683 9.33398Z"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_21887_11021">
              <rect width="18" height="18" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
    },
    {
      id: 'Brand',
      path: '/brand',
      label: 'Brand',
      icon: (
        <svg
          width="18"
          height="18"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8 1.33398L14.6667 8.00065L8 14.6673L1.33333 8.00065L8 1.33398Z"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },
  ];

  if (isAppSumoTier3 || isBusinessPlan) {
    baseOptions.push({
      id: 'teams',
      path: ROUTES.Teams,
      label: 'Teams',
      icon: <FiUsers size={18} />,
    });
  }

  return baseOptions;
};

export const OTHER_OPTIONS = [
  {
    id: 'community-tutorials',
    path: 'https://community.vocable.ai/c/vocable-tutorials/',
    label: 'Community + Tutorials',
    external: true,
    icon: (
      <svg
        width="18"
        height="18"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.6668 7.99984C14.6668 11.6818 11.6821 14.6665 8.00016 14.6665C4.31826 14.6665 1.3335 11.6818 1.3335 7.99984C1.3335 4.31794 4.31826 1.33317 8.00016 1.33317C11.6821 1.33317 14.6668 4.31794 14.6668 7.99984Z"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.66683 6.33317L10.0002 7.99984L6.66683 9.6665V6.33317Z"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    id: 'share-earn',
    path: 'https://vocableai.getrewardful.com/signup',
    label: 'Share & Earn',
    external: true,
    icon: (
      <svg
        width="18"
        height="18"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 5.33333C13.1046 5.33333 14 4.43791 14 3.33333C14 2.22876 13.1046 1.33333 12 1.33333C10.8954 1.33333 10 2.22876 10 3.33333C10 4.43791 10.8954 5.33333 12 5.33333Z"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4 10C5.10457 10 6 9.10457 6 8C6 6.89543 5.10457 6 4 6C2.89543 6 2 6.89543 2 8C2 9.10457 2.89543 10 4 10Z"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 14.6667C13.1046 14.6667 14 13.7712 14 12.6667C14 11.5621 13.1046 10.6667 12 10.6667C10.8954 10.6667 10 11.5621 10 12.6667C10 13.7712 10.8954 14.6667 12 14.6667Z"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.72656 9.00667L10.2799 11.66"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.2732 4.34L5.72656 6.99333"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
];

export const TOOLS_SIDEBAR_OPTIONS = [];

export const TOOL_PATHS = [];
